import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Default storage (localStorage for web)
import { thunk } from "redux-thunk";
import { combineReducers } from "redux";
import authReducer from "./authSlice";
import apiSlice from "./apiSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  api: apiSlice,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"], // Only persist 'auth' slice (add more if needed)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools in non-production environments
});

// Set up persistor for persisting the store
const persistor = persistStore(store);

export { store, persistor };
